import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "shared/components/ui/tooltip";
import styles from "./indicatoriFinanziari.module.scss";
import { QuestionMarkIcon } from "shared/assets/svg/QuestionMarkIcon";
import { useTranslation } from "react-i18next";
import { useComparisonLabels } from "../../../compare/ComparisonLabelsContext";

type IndicatoreFinanziarioData = {
  label: string;
  description: string;
  value: string;
};

type Props = {
  reportData: any;
  reportData2?: any;
};

const IndicatoriFinanziari: React.FC<Props> = ({
  reportData,
  reportData2 = null,
}) => {
  useTranslation();
  const labels = useComparisonLabels();
  const indicatoriFinanziari: IndicatoreFinanziarioData[] =
    reportData.indicatori_finanziari;
  let indicatoriFinanziari2: IndicatoreFinanziarioData[] = null;
  if (reportData2) {
    indicatoriFinanziari2 = reportData2.indicatori_finanziari;
  }

  if (!indicatoriFinanziari) {
    return null;
  }

  const renderBars = (value: string) => {
    const getBarCount = (value: string) => {
      switch (value) {
        case "Rosso":
          return 1;
        case "Giallo":
          return 2;
        case "Verde":
          return 3;
        case "Neutro":
          return 3;
        default:
          return 0;
      }
    };

    const getBarColor = (value: string) => {
      switch (value) {
        case "Rosso":
          return styles.redBar;
        case "Giallo":
          return styles.yellowBar;
        case "Verde":
          return styles.greenBar;
        case "Neutro":
          return styles.neutralBar;
        default:
          return "";
      }
    };

    const barCount = getBarCount(value);
    const barColor = getBarColor(value);

    return (
      <div className={styles.barsContainer}>
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className={`${styles.bar} ${index < barCount ? barColor : styles.emptyBar}`}
          />
        ))}
      </div>
    );
  };

  return (
    <div className={styles.indicatoriFinanziariMargins}>
      <div className={styles.indicatoriFinanziari}>
        {!reportData2 && (
          <div className={styles.indicatorsGrid}>
            {indicatoriFinanziari.map(
              (indicator: IndicatoreFinanziarioData) => (
                <div key={indicator.label} className={styles.indicatorItem}>
                  <div className={styles.indicatorHeader}>
                    <span className={styles.indicatorLabel}>
                      {indicator.label}
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger>
                            <div className={styles.infoIcon}>
                              <QuestionMarkIcon />
                            </div>
                          </TooltipTrigger>
                          <TooltipContent>
                            {indicator.description}
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </span>
                  </div>
                  {renderBars(indicator.value)}
                </div>
              ),
            )}
          </div>
        )}
        {reportData2 && (
          <div className={styles.indicatorsGrid2}>
            <div className={styles.indicatorTitleItem}>
              {labels.portfolio1}
            </div>
            {indicatoriFinanziari.map(
              (indicator: IndicatoreFinanziarioData) => (
                <div key={indicator.label} className={styles.indicatorItem}>
                  <div className={styles.indicatorHeader}>
                    <span className={styles.indicatorLabel}>
                      {indicator.label}
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger>
                            <div className={styles.infoIcon}>
                              <QuestionMarkIcon />
                            </div>
                          </TooltipTrigger>
                          <TooltipContent>
                            {indicator.description}
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </span>
                  </div>
                  {renderBars(indicator.value)}
                </div>
              ),
            )}
            <div className={styles.indicatorTitleItem}>
              {labels.portfolio2}
            </div>
            {indicatoriFinanziari2 &&
              indicatoriFinanziari2.map(
                (indicator: IndicatoreFinanziarioData) => (
                  <div key={indicator.label} className={styles.indicatorItem}>
                    <div className={styles.indicatorHeader}>
                      <span className={styles.indicatorLabel}>
                        {indicator.label}
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger>
                              <div className={styles.infoIcon}>
                                <QuestionMarkIcon />
                              </div>
                            </TooltipTrigger>
                            <TooltipContent>
                              {indicator.description}
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </span>
                    </div>
                    {renderBars(indicator.value)}
                  </div>
                ),
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(IndicatoriFinanziari);
